import React from 'react';

const PresentedDielineOptions = () => {
  const presentedDielineOptions = window.user_quote?.presented_dieline_options || {};
  // Preserve the order the Ruby side established (material first, then dimensions
  // in form-sidebar order). Object.entries keeps insertion order; do not re-sort.
  const optionEntries = Object.entries(presentedDielineOptions);

  if (optionEntries.length === 0) {
    return null;
  }

  return (
    <table className="table table-striped table-bordered-outside" style={{ marginTop: '10px' }}>
      <tbody>
        {optionEntries.map(([key, value]) => (
          <tr key={key}>
            <td>{key}</td>
            <td align="right">{value}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default PresentedDielineOptions;
